import PropTypes from 'prop-types';
import UserProvider from './auth-context';
import NotificationProvider from './Notification/NotificationProvider';
import PermissionProvider from './permission-context';
import { XflowProvider } from './xflow-context';

function AppProvider({ children }) {
    return (
        <UserProvider>
            <PermissionProvider>
                <NotificationProvider>
                    <XflowProvider>{children}</XflowProvider>
                </NotificationProvider>
            </PermissionProvider>
        </UserProvider>
    );
}

// Props
AppProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AppProvider;
